import { Link } from 'react-router-dom';

import { useCreditsQuery } from '@/features/credits/useCreditsQuery';
import { PacksSection } from '@/features/payments/PacksSection';
import { RewardedAdButton } from '@/features/rewards/RewardedAdButton';
import { plural } from '@/utils/plural';

/**
 * Баланс и способы его пополнить.
 *
 * Экран не называет ни стартовый лимит, ни размер наград числами из кода:
 * лимиты живут в серверной конфигурации, и продублированное здесь число
 * рано или поздно разошлось бы с настоящим.
 */
export function CreditsPage() {
  const { data, isPending, isError, refetch } = useCreditsQuery();

  return (
    <main className="flex flex-col gap-6 px-6 py-8">
      <div>
        <h1 className="font-display text-h1 text-text">Кредиты</h1>

        {isPending && <p className="mt-2 text-text-2">Загрузка баланса…</p>}

        {isError && (
          <div className="mt-2">
            <p className="text-danger">Не удалось узнать остаток. Попробуйте ещё раз.</p>
            <button
              type="button"
              onClick={() => void refetch()}
              className="mt-2 text-sm text-accent hover:underline"
            >
              Повторить
            </button>
          </div>
        )}

        {data !== undefined && (
          <p className="mt-2 text-text">
            Осталось{' '}
            <span className="tabular-nums text-text">
              {data} {plural(data, ['генерация', 'генерации', 'генераций'])}
            </span>
            .
          </p>
        )}

        <p className="mt-2 text-sm text-text-2">
          Портрет тратит один кредит, фотосессия — по кредиту за кадр.
        </p>
      </div>

      <PacksSection />

      <section className="flex flex-col gap-3">
        <h2 className="text-lg font-semibold text-text">Как получить ещё</h2>

        <RewardedAdButton />

        <Link
          to="/invite"
          className="btn btn-secondary px-4 py-3 text-sm"
        >
          Пригласить друга
        </Link>

        <p className="text-sm text-text-3">
          За приглашение кредит начисляется, когда друг создаст свой первый портрет.
        </p>
      </section>
    </main>
  );
}
